<template>
	<div style="width:100%;height:100%">
		<!-- 功能按钮 -->
		<buttonlist
			@help="help"
			@opentable="opentable"
			@search="search"
			@reflash="reflash"
			@exps="exp"
			ref="SetBtn"
		></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<wTable
				id="xpane-0"
				:data="datajson"
				:loading="loading"
				queryData="ISSQuotationBatchViewInfo"
				:filter_language="['isFirstVenderName','isValidName','ce_flag']"
				:filter_thousandth="['batch_floor_limit','price','net_price','Shipment_Cycle','moq']"
				:header="tableHeader"
				:option="tableOption"
				:row-class-name="tableRowClassName"
				:checkflg="false"
				ref="singleTable"
		></wTable>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="16">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[50, 100, 200, 300, 400]"
					:page-size="PageSize"
					background
					small
					pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="8">
				<div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 搜索弹框 -->
		<serce :isVisible="isVisible" queryData="ISSQuotationBatchViewInfo" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[6014]')" queryData="ISSQuotationBatchViewInfo" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
	</div>
</template>

<script>
import Common from '@/components/Common';
export default {
	name:'wxbatchoverview',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
            tableHeader: [],
			DbTbNames: '', //表名
			datajson: [],
			PageIndex: 1,
			PageSize: this.$http.getPageSize('wxbatchoverview'),
			SelectIndex: 1,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			queryData: [], // 查询数组
			isVisible: false,
            scrollTop:0,
		};
	},
	create() {},
	beforeMount() {},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted() {
		let that = this;
        that.colsort();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('ISSQuotationBatchViewInfo', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8173]"),this.$t("getapi[13]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
			//只读权
			if (that.$limits.authority('plv2', 153, 1) >= 1) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
		},
		//表格背景
		tableRowClassName({ row, rowIndex }) {
			if (row.enable_flag == '是') {
				return 'warning-row';
			}
			if (row.version_status == '不可用') {
				return 'dark-row';
			}
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.intidata();
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
			this.intidata();
			this.authority();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
            this.$http.savePageSize('wxbatchoverview',val)
			this.intidata();
			this.authority();
		},
		// 获取数据
		intidata() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			let pm = {
				query_Condition: '',
				query_field_type: '',
				query_field_name: '',
				row_sign: '',
				query_sort: ''
			};
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Param: []
			};
			that.queryData.forEach(item => {
				if(item.query_Condition==''||item.query_Condition.length>0) {
					pm = {
						row_sign: item.row_sign,
						query_Condition: item.query_Condition,
						query_sort: item.query_sort,
						query_field_type: item.Query_Field_Type,
						query_field_name: item.Query_Field_Name
					};
					parm.Param.push(pm);
				}
			});
			that.$http.urlpost('/Iss/QuotationBatch/DataList', parm, function(res) {
				if (res.Success == 1) {
					that.datajson = res.DataContent;
					that.total = res.Totals;
					that.DbTbNames = res.DbTbNames;
				}
				that.loading = false;
				that.authority();
			});
		},

		// 查询
		search() {
			this.isVisible = true;
			this.$refs.ser.clearInput(this.isVisible, 'ISSQuotationBatchViewInfo');
		},
		// 刷新
		reflash() {
			this.intidata();
		},
		// 导出
		exp() {
			/*let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/Iss/QuotationBatch/ListToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "ISSQuotationBatchViewInfo",
                fromname: that.$t('getapi[8173]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
	}
};
</script>

<style lang="scss" scoped>
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.bbl {
	margin: 10px auto;
	span {
		width: 70px;
		text-align: left;
		line-height: 40px;
		display: inline-block;
	}
}
</style>
